import React from "react"
import styles from "./index.module.scss"
import { useRouter } from "next/router"

const PromotionTitle = ({ promotionTitleData }) => {
  if (!promotionTitleData?.promotionTitleArray?.length) return null

  const items = promotionTitleData.promotionTitleArray
  const isSingleItem = items.length === 1
  const router = useRouter(); 
  return (
    <section className={styles.section}>
      <div
        className={`${styles.grid} ${isSingleItem ? styles.singleItem : ""}`}
      >
        {items.map((item, index) => {
          const {
            backgroundImage,
            avtarImage,
            firstName,
            lastName,
            videoUrl,
            description,
          } = item.fields

          const bio = description?.content?.[0]?.content?.[0]?.value || ""
          return (
            <div key={index} className={styles.tile}>
              <div className={styles.thumbnail}>
                <img
                  src={`${backgroundImage.includes("http") ? backgroundImage : `https:${backgroundImage}`}`}
                  alt={`${firstName} ${lastName}`}
                  className={styles.bgImg}
                />
                <div className={styles.gradient} />
              </div>
              <div className={styles.info}>
                <div className={styles.profile}>
                  <img
                    src={`${avtarImage.includes("http") ? avtarImage : `https:${avtarImage}`}`}
                    alt="profile"
                  />
                </div>
                <div className={styles.text}>
                  <div className={styles.name}>
                    <strong>{firstName}</strong> {lastName}
                  </div>
                  <p className={styles.bio}>{bio}</p>
                </div>
                <div className={styles.videoPlayButton} onClick={() => videoUrl && router.push(videoUrl)}>
                  <svg
                    width="61"
                    height="62"
                    className={styles.playIcon}
                    data-source={videoUrl}
                    viewBox="0 0 61 62"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      opacity="0.4"
                      y="0.25293"
                      width="61"
                      height="61"
                      rx="30.5"
                      fill="white"
                    />
                    <path
                      d="M8.37268 30.8277C8.37268 18.5658 18.3129 8.62549 30.5749 8.62549C42.8368 8.62549 52.7771 18.5658 52.7771 30.8277C52.7771 43.0896 42.8368 53.0299 30.5749 53.0299C18.3129 53.0299 8.37268 43.0896 8.37268 30.8277Z"
                      fill="white"
                    />
                    <path
                      d="M27.6669 35.7305C27.882 35.7305 28.0714 35.6537 28.307 35.5154L34.3539 32.0183C34.7942 31.7623 34.9786 31.5626 34.9786 31.2401C34.9786 30.9175 34.7942 30.7229 34.3539 30.4618L28.307 26.9647C28.0714 26.8264 27.882 26.7496 27.6669 26.7496C27.2471 26.7496 26.9501 27.0722 26.9501 27.5791V34.901C26.9501 35.413 27.2471 35.7305 27.6669 35.7305Z"
                      fill="#1C1C1E"
                    />
                  </svg>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
export default PromotionTitle
